import { useQuery } from "@tanstack/react-query";
import { getServiceById } from "../../api/apiServices";

/**
 * Hook لجلب خدمة واحدة
 * @param {number|string} id - Service ID
 */
export function useGetService(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["service", id],
        queryFn: () => getServiceById(id),
        enabled: !!id,
        retry: false,
    });

    const service = data?.data || null;

    return { isLoading, error, service, refetch };
}